<script>
import { Bar } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import 'chartjs-plugin-piechart-outlabels'
import _cloneDeep from 'lodash/cloneDeep'
import _isNumber from 'lodash/isNumber'
import { mapState } from 'vuex'

export default {
  extends: Bar,

  name: 'BarChartYear',

  props: {
    yearDatasets: {
      type: Array,
      default: () => []
    }
  },

  components: { ChartJsPluginDataLabels },

  data () {
    return {
      chartdata: {
        labels: ['合計'],
        datasets: _cloneDeep(this.yearDatasets)
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: ({ datasetIndex, yLabel }, { datasets }) => {
              const formattedYLabel = this.$util.numberWithCommas(
                _isNumber(yLabel) ? yLabel : 0
              )
              const datasetLabel = datasets[datasetIndex].label

              return `${datasetLabel}: ${formattedYLabel}`
            }
          }
        },
        legend: {
          display: false,
          onClick () {
            return null
          }
        },
        layout: {
          padding: {
            top: 20
          }
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontColor: '#6E6B7B',
                fontSize: 12
              },
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                fontColor: '#B9B9C3',
                fontSize: 12,
                beginAtZero: true,
                callback: (val) => {
                  return this.$util.shortManNumber(val)
                }
              },
              gridLines: {
                drawOnChartArea: false
              }
            }
          ]
        },
        plugins: {
          datalabels: {
            font: {
              size: 10
            },
            formatter: (val) => {
              return this.$util.numberSymbolFormatter(val)
            },
            color: '#6E6B7B',
            align: 'end',
            anchor: 'end',
            offset: -4,
            clamp: false
          }
        }
      }
    }
  },

  mounted () {
    this.addPlugin(ChartJsPluginDataLabels)
    this.renderChart(this.chartdata, this.options)
  },

  watch: {
    yearDatasets: {
      handler (newVal) {
        this.chartdata.datasets = _cloneDeep(newVal)
        this.renderChart(this.chartdata, this.options)
      },
      deep: true
    },
    currentLanguage: {
      handler (newVal) {
        if (newVal) {
          this.updateChartLabels()
        }
      }
    }
  },

  computed: {
    ...mapState(['currentLanguage'])
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    updateChartLabels () {
      this.chartdata.labels = ['合計'].map(label => this.translations(`dashboard.${label}`))
      this.renderChart(this.chartdata, this.options)
    }
  }
}
</script>
